var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Disagreements"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.rm
                    ? _c("h3", { staticClass: "text-center" }, [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading...\n                    "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rm
                    ? _c("div", { staticClass: "table-responsive" }, [
                        _c("table", { staticClass: "table table-bordered" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.questions, function (q) {
                              return _c("tr", { key: q.Id }, [
                                _c("td", [_vm._v(_vm._s(q.Title))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("span", [_vm._v(_vm._s(q.ContextName))]),
                                  _vm._v(" "),
                                  q.ContextPath
                                    ? _c("small", [
                                        _c("br"),
                                        _vm._v(
                                          "\n                                            Path: " +
                                            _vm._s(q.ContextPath) +
                                            "\n                                        "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(q.DisagreementStatus)),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showQuestion(q.Id)
                                        },
                                      },
                                    },
                                    [_vm._v("show")]
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Question")]),
        _vm._v(" "),
        _c("th", [_vm._v("Context")]),
        _vm._v(" "),
        _c("th", [_vm._v("Disagreement")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }